import type {ReactElement} from 'react';
import React from 'react';
import {MODALS_IDS} from '@Components/modal-container';
import {GlobalPosterEditorJqueryElement} from '@Components/poster-editor/poster-editor.types';
import {POSTER_PUSH_MODAL_IDS} from '@Components/poster-editor/components/post-poster-modal-spacer/post-poster-modal-spacer.types';
import {useAppSelector} from '@/hooks';
import styles from './post-poster-modal-spacer.module.scss';
import {useIsTimelineButtonVisible} from '@Hooks/poster-editor/useIsTimelineButtonVisible';
import type {RootState} from '@/store';

const MIN_POSTER_WHITEBOARD_HEIGHT = 200;

const selectOpenedModalId = (state: RootState): string | undefined => {
  for (const [modalId, modalData] of Object.entries(state.modals.modalsHashmap)) {
    if (modalData.isOpen) {
      return modalId;
    }
  }
  return undefined;
};

const selectOpenedModalHeight = (state: RootState): number | undefined => {
  for (const [, modalData] of Object.entries(state.modals.modalsHashmap)) {
    if (modalData.isOpen) {
      return modalData.height;
    }
  }
  return undefined;
};

export function PostPosterModalSpacer(): ReactElement<any> {
  const isTimelineButtonVisible = useIsTimelineButtonVisible();
  const openedModalId = useAppSelector(selectOpenedModalId);
  const openedModalHeight = useAppSelector(selectOpenedModalHeight);
  const bottomBarHeight = window.posterEditor?.elements[GlobalPosterEditorJqueryElement.POSTER_EDITOR_MOBILE_BOTTOM_EDITING_BAR]?.outerHeight(true) || 0;
  const navbarHeight = window.posterEditor?.elements[GlobalPosterEditorJqueryElement.POSTER_EDITOR_NAVBAR]?.outerHeight(true) || 0;
  let height = 0;
  if (openedModalId && POSTER_PUSH_MODAL_IDS[openedModalId] && openedModalHeight) {
    height = Math.max(openedModalHeight - bottomBarHeight, 0);
  }

  if (openedModalId === MODALS_IDS.POSTER_EDITOR_MORE_OPTIONS_MODAL) {
    if (openedModalHeight && openedModalHeight < 100) {
      height = 0;
    }
  }

  const getMaxHeight = (): number => {
    return window.innerHeight - MIN_POSTER_WHITEBOARD_HEIGHT - navbarHeight - bottomBarHeight - (isTimelineButtonVisible ? 80 : 0);
  };

  return (
    <div
      className={styles.container}
      style={{
        maxHeight: `${getMaxHeight()}px`,
        minHeight: `${height > getMaxHeight() ? getMaxHeight() : height}px`,
        height: `${height}px`,
        width: '1px',
      }}
    />
  );
}
